import Image from '~/components/common/Image'

// Cart Icon
export const CartIcon = () => (
  <Image width="22" height="22" src="/cart-white.svg" alt="cart icon" />
)
